module.exports = {
  AngleUnits: ["deg", "rad"],
  Dimension: ["width", "height"],
  Direction: ["clock", "anticlock"],
  FontStyle: ["normal", "italic", "bold"],
  LineCap: ["butt", "round", "square"],
  LineJoin: ["miter", "round", "bevel"],
  Location: ["above", "below", "left", "right"],
  LegendLocation: ["top_left", "top_center", "top_right", "left_center", "center", "right_center", "bottom_left", "bottom_center", "bottom_right"],
  Orientation: ["vertical", "horizontal"],
  RenderLevel: ["image", "underlay", "glyph", "annotation", "overlay", "tool"],
  RenderMode: ["canvas", "css"],
  Side: ["left", "right"],
  SpatialUnits: ["screen", "data"],
  StartEnd: ["start", "end"],
  TextAlign: ["left", "right", "center"],
  TextBaseline: ["top", "middle", "bottom", "alphabetic", "hanging", "ideographic"],
  DistributionTypes: ["uniform", "normal"],
  TransformStepModes: ["after", "before", "center"],
  SizingMode: ["stretch_both", "scale_width", "scale_height", "scale_both", "fixed"]
};
